import { useEffect, useState } from "react";
import swal from 'sweetalert2';
import { getMemberUserAllByID, getTeeTimeBookMemberList, postFavouriteUser } from "../api/teeTimeAPI";
import defaultlogo from '../../assets/images/defaultlogo.jpg';
import { getAuthState } from "../../assets/scripts/login-util";

const imgUrl = 'https://golfez.s3.ap-south-1.amazonaws.com/Public/OGR/User/';

const AddMember = (props) => {
  const [members, setMembers] = useState([]);
  const [filteredMembers, setFilteredMembers] = useState([]);

  useEffect(() => {
    $("#modalMember").modal({ backdrop: "static", keyboard: false });
    $(props.from).addClass("modal-blur");
    $("#modalMember").on("hidden.bs.modal", function () {
      $(".modal").hasClass("show") && $("body").addClass("modal-open");
      props.onDismissModal(false);
    });
    fetchActiveMembers();
  }, []);


  const fetchActiveMembers = async () => {
    try {
      const user = getAuthState("user");
      const { TeeTimeMembers } = await getTeeTimeBookMemberList(user.id);

      if (props.members && props.members.length > 0) {
        // removes selected and self member's
        const filtered = TeeTimeMembers.filter(
          (g) =>
            g.UserID != user?.id &&
            props.members.findIndex(
              (f) => f.UserID == g.UserID && f.UserType == "User"
            ) === -1 && !props?.otherMembers?.some(e => e.UserID === g.UserID)
        );
        setMembers(filtered);
        setFilteredMembers(
          filtered
          .filter((m) => m.IsActive === "Y")
          .sort((a, b) => new Date(b.UpdatedAt) - new Date(a.UpdatedAt))
        );

      } else {
        setMembers(TeeTimeMembers.filter((g) => g.UserID != user?.id && !props?.otherMembers?.some(e=>e.UserID === g.UserID )));
        setFilteredMembers(
          TeeTimeMembers.filter(
            (m) => m.UserID != user?.id && m.IsActive == "Y" && !props?.otherMembers?.some(e=>e.UserID === m.UserID )
          ).sort((a, b) => new Date(b.UpdatedAt) - new Date(a.UpdatedAt))
        );
      }
      return;
    } catch (err) {
      swal.fire({ icon: "error", titleText: "Error!", text: err.message });
      return;
    }
  };

  // const addPlayerHandler = (player) => {
  //     console.log("plyer",player)
  //     if(props.from == 'header') return;

  //     props.setMembers((d) => [
  //       ...d,
  //       {
  //         UserID: player.UserID,
  //         UserName: `${player?.FirstName || ""} ${player?.MiddleName} ${
  //           player.LastName
  //         } (${player.MembershipNo})`,
  //         UserType: "User",
  //       },
  //     ]);
  //     $('#modalMember').modal('hide');
  //     $(props.from).removeClass('modal-blur');
  // }

  const addPlayerHandler = async (player) => {

    if (props.from === "header") return;

    try {
      // Create new member object with proper structure
      const newMember = {
        UserID: player.UserID,
        UserName:
          player.UserName ||
          `${player?.FirstName || ""} ${player?.MiddleName || ""} ${
            player?.LastName || ""
          }`.trim() ||
          "Unknown User",
        UserType: "User",
        CategoryID: player.CategoryID || 1,
        SubCategoryID: player.SubCategoryID || 1,
        IsValidMember: getIsValidMember(player,props.SelectedDate,props.isWeekend),
        SubscriptionExpiresOn: player.SubscriptionExpiresOn,
        MembershipExpiresOn: player.MembershipExpiresOn,
        // IsValidMember: "Y",
        // IsCartRequired: "Y",
        // IsCaddyRequired: "Y",
        // IsChecked: true,
        // IsDisabled:"Y",
        IsCartRequired: "N",
        IsCaddyRequired: "N",
        IsChecked: false,
        IsCartUpdated   : false,
        MembershipNo: player.MembershipNo || "",
      };

      // const { TeeTimeMembers } = await getTeeTimeBookMemberList();

      // const newMember = TeeTimeMembers.filter((m) => m.UserID == player.id);

      // Add membership number to display name if available
      if (newMember.MembershipNo) {
        newMember.UserName = `${newMember.UserName} (${newMember.MembershipNo})`;
      }

      // Get current members and add the new one
      const updatedMembers = [...props.members, newMember];
      // Pass the updated array to parent
      props.setMembers(updatedMembers);

      // Hide modal safely
      if (typeof $ !== "undefined") {
        $("#modalMember").modal("hide");
        if (props.from) {
          $(props.from).removeClass("modal-blur");
        }
      }
    } catch (error) {
      console.error("Error adding player:", error);
      // You might want to show an error message to user here
    }
  };

  const onMemberFavourite = async (p) => {
    try {
      await postFavouriteUser(p.UserID);
      const user = getAuthState("user");
      const { TeeTimeMembers } = await getTeeTimeBookMemberList(p.UserID);
      setFilteredMembers(
        TeeTimeMembers.filter(
          (m) => m.UserID != user?.id && m.IsActive == "Y" && !props?.otherMembers?.some(e=>e.UserID === m.UserID )
        )
      );
      
      $("#txtSearch").val("");
      fetchActiveMembers();
    } catch (err) {
      swal.fire({ icon: "error", titleText: "Error!", text: err.message });
      return;
    }
  };

  const getIsValidMember = (member, selectedDate, isWeekend) => {
    const selected = moment(selectedDate, 'YYYY-MM-DD');
    
    const isSubscriptionExpired = member.SubscriptionExpiresOn ? moment(member.SubscriptionExpiresOn).isBefore(selected) : true;
    const isMembershipExpired = member.MembershipExpiresOn ? moment(member.MembershipExpiresOn).isBefore(selected) : true;
  
    const isInvalidCategoryOnWeekend =
      member.SubCategoryID === 7 && isWeekend === "Y";
  
    const isInvalid = isSubscriptionExpired || isMembershipExpired || isInvalidCategoryOnWeekend;
  
    return isInvalid ? "N" : "Y";
  };

  const onMemberSearch = (searchTerm) => {
    if (!searchTerm || searchTerm === "")
      return setFilteredMembers(members.filter((m) => m.IsFavourite == "Y" && !props?.otherMembers?.some(e=>e.UserID === m.UserID )));

    //filter as per searched
    const filtered = members.filter((m) => {
      let matchString = `${m.FirstName} ${m?.MiddleName} ${m.LastName} ${m.MembershipNo}`;
      let matchFound = 0;
      var searchArr = searchTerm.split(" ");

      searchArr.forEach(
        (t) =>
          (matchFound += matchString.toLowerCase().includes(t.toLowerCase())
            ? 1
            : 0)
      );

      return matchFound === searchArr.length;
    });

    setFilteredMembers(filtered);
  };

  const onClose = () => $(props.from).removeClass("modal-blur");

  return (
    <>
      <div
        id="modalMember"
        className="modal fade modal-responsive"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header padding-b0">
              <button type="button" className="close" data-dismiss="modal">
                <span aria-hidden="true" onClick={onClose}>
                  &times;
                </span>
              </button>
              <h5 className="modal-title" id="member-modal-title">
                Search Member
              </h5>
            </div>
            <div className="modal-body overflow-x- padding-t0">
              <div id="ModalMemberHolder">
                <div className="row sticky-search">
                  <div className="col-sm-10 col-xs-8">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        id="txtSearch"
                        name="txtSearch"
                        placeholder="Search Member..."
                        onChange={({ target }) => onMemberSearch(target.value)}
                      />
                    </div>
                  </div>
                </div>

                <div id="messageModelMember"></div>

                <div className="row " id="memberContainer">
                  <div className="col-sx-12">
                    <table
                      id="table-member"
                      className="table table-bordered table-hover "
                    >
                      <tbody>
                        {filteredMembers.length > 0 &&
                          filteredMembers.map((m, i) => (
                            // <tr key={m.UserID}>
                            <tr key={i}>
                              <td>
                                <div
                                  className="media member-slot"
                                  onClick={() => addPlayerHandler(m)}
                                >
                                  <div className="media-left">
                                    {m.Photo && m.Photo != "" ? (
                                      <img
                                        src={`${imgUrl}${m.Photo}`}
                                        onError={(e) =>
                                          (e.currentTarget.src = defaultlogo)
                                        }
                                        alt="user-profile"
                                        className="media-member-img"
                                      />
                                    ) : (
                                      <img
                                        src={defaultlogo}
                                        alt="user-profile"
                                        className="media-object img-circle img-user-list-sm"
                                      />
                                    )}
                                  </div>
                                  <div className="media-body vertical-align-middle">
                                    <p className="user-detail margin-b0">
                                      <span className="name">
                                        {" "}
                                        {`${m.DisplayName}`}{" "}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </td>
                              <td className="media-icon">
                                <i
                                  className={`fa ${
                                    m.IsActive == "Y"
                                      ? "fa-star"
                                      : "fa-star-o"
                                  }  favIcon`}
                                  onClick={() => onMemberFavourite(m)}
                                >
                                  {" "}
                                </i>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddMember;